import { useMemo } from 'preact/hooks'
import { checkConditions } from '@/components/helpers/metaobjects'
import { globalState } from '@/components/helpers/utils'
import { Criteria } from '@/components/helpers/metaobjects.types'

/**
 * Takes a criteria object to pass to checkConditions to validate what swatches should display.
 */

export function useSwatches(criteria: Criteria) {
  return useMemo(() => {
    const data = globalState.metaobjects.swatches
    return data.filter((swatch) => checkConditions(swatch, criteria)).sort((a, b) => a.priority - b.priority)
  }, [criteria])
}
